const textblockTypes = {
    SET_TEXTBLOCK_TEXT: 'SET_TEXTBLOCK_TEXT'
};

export default textblockTypes;